import { FormattedMessage } from 'react-intl';
import { Chip } from 'components/ui';

const STATUS_COLORS = {
  completed: 'success',
  pending: 'default',
  canceled: 'warning',
  failed: 'error',
};

const State = ({ status }) => {
  return (
    <Chip
      variant="outlined"
      size="small"
      color={STATUS_COLORS[status] || 'default'}
      label={<FormattedMessage id={`order.status.${status}`} />}
    />
  );
};

export default State;
